
import OrderRequestBill from "@/assets/js/Bill/OrderRequestBill";
import dialogCom from "@/components/ModelCom.vue";
import pageCom from "@/components/PageCom.vue";
import Vue from "vue";
export default Vue.extend({
  components: { dialogCom, pageCom },
  data() {
    return {
      title: { title: "选择资产" },
      items: [] as any[],
      currentPage: 0,
      pageSize: 100,
      total: 0,
      search: null as any,
      current: null as any,
    };
  },
  methods: {
    open(content: string) {
      this.search = content;
      this.select();
      const dialog: any = this.$refs.assetDialog;
      dialog.show();
    },
    hiden() {
      const dialog: any = this.$refs.assetDialog;
      dialog.hiden();
    },
    async select() {
      const content = { searchStr: this.search };
      const ret = await OrderRequestBill.GetAssets(
        content,
        this.currentPage,
        this.pageSize
      );
      this.items = ret.data;
      this.total = ret.total;
    },
    currentChange(val: any) {
      if (val == null) {
        return;
      }
      this.current = val;
      this.$emit("assetChoosed", val);
      this.hiden();
    },
    change() {
      this.select();
    },
  },
});
